import { render, staticRenderFns } from "./ModalDisplayRole.vue?vue&type=template&id=1b2aa3cd&scoped=true"
import script from "./ModalDisplayRole.vue?vue&type=script&lang=js"
export * from "./ModalDisplayRole.vue?vue&type=script&lang=js"
import style0 from "./ModalDisplayRole.vue?vue&type=style&index=0&id=1b2aa3cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2aa3cd",
  null
  
)

export default component.exports